<template>
  <!-- 卡片组件 -->
  <div>
    <slot name="card_title"> </slot>

    <div class="c_box" v-for="(item, index) in card_list" :key="index">
      <div class="c_box_title" v-if="item.email_card_level_name">
        {{ item.email_card_level_name }}
      </div>
      <div class="card_box">
        <div class="c_box_left">
          <!-- :style="
              item.card_picture
                ? 'background:url(' +
                  item.card_picture +
                  ');background-size:100% 100%;'
                : ''
            " -->
          <div class="card_bgc">
            <div class="cardBg">
              <img :src="item.card_picture" alt="" />
              <!-- <img src="../assets/img/cardBg.png" alt="" /> -->
            </div>
            <div class="card_logo_box">
              <span>{{ item.card_name.toUpperCase() }}</span>
              <img
                class="look_icon"
                v-if="!item.num_is_show"
                @click="item.num_is_show = !item.num_is_show"
                src="../assets/img/look_icon.png"
                alt=""
              />
              <img
                class="look_icon"
                v-else
                @click="item.num_is_show = !item.num_is_show"
                src="../assets/img/look_icon_no.png"
                alt=""
              />
            </div>

            <div class="cord_num">
              <span v-if="!item.num_is_show">....</span>
              <span v-else>{{ item.number.substr(0, 4) }}</span>
              <span v-if="!item.num_is_show">....</span>
              <span v-else>{{ item.number.substr(4, 4) }}</span>
              <span v-if="!item.num_is_show">....</span>
              <span v-else>{{ item.number.substr(8, 4) }}</span>
              <span v-if="!item.num_is_show">{{
                item.number.substr(12, 4) || "...."
              }}</span>
              <span v-else>{{ item.number.substr(12, 4) }}</span>
            </div>
            <div class="cord_text">
              <!-- {{ item.card_name.toUpperCase() }} -->
              <!-- XIAOZHANXIAOZHANXIAO -->
            </div>
            <div class="cord_btm_num">
              <div>
                <div class="btm_t1">{{ $t("main.text690") }}</div>
                <div class="btm_t2" v-if="!item.num_is_show">...</div>
                <div class="btm_t2" v-else>{{ item.expire_date }}</div>
              </div>
              <div>
                <!-- <img class="btm_t_img" src="../assets/img/visa.png" alt="" /> -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="c_box_right"
          :class="
            [3, 4, 5].includes(item.status) ? 'right_color2' : 'right_color'
          "
        >
        <div class="c_right_t1 c_t_txt1">
            {{ $t("bank_card.Subaccount_status") }}: 
            <span v-if="item.account_status==1">{{$t("bank_card.status_1")}}</span>
            <span v-else-if="item.account_status==2">{{$t("bank_card.KYC_Processing")}}</span>
            <span v-else-if="item.account_status==3">{{$t("bank_card.kyc_approved")}}</span>
            <span v-else-if="item.account_status==4">{{$t('main.text649')}}</span>
            <span v-else-if="item.account_status==5">{{$t("bank_card.Card_Binded2")}}</span>
            <span v-else-if="item.account_status==6">{{$t("bank_card.Activated")}}</span>
            <span v-else-if="item.account_status==7">{{$t("bank_card.Printing")}}</span>
            <span v-else-if="item.account_status==8">{{$t("bank_card.freeze")}}</span>
            <span v-else-if="item.account_status==9">{{$t("bank_card.Cancelled")}}</span>
            <span v-else-if="item.account_status==10">{{$t("bank_card.mailed_s")}}</span>
            <span v-else-if="item.account_status==11">{{$t("bank_card.Card_anomaly")}}</span>
            <!-- <span v-else-if="item.account_status==12">{{$t("bank_card.Refuse_card")}}</span> -->
            <span v-else-if="item.account_status==13">{{$t("bank_card.Rep_card")}}</span>
            <span v-else-if="item.account_status==14">{{$t("bank_card.replacement_card")}}</span>
            <span v-else-if="item.account_status==15">{{$t("bank_card.Reissued_card")}}</span>
            <span v-else-if="item.account_status==16">{{$t("bank_card.Consolidating")}}</span>
            <span v-else-if="item.account_status==17">{{$t("bank_card.Pending_Rebind")}}</span>
            <span v-else-if="item.account_status==18">{{$t("bank_card.Cancelling")}}</span>
            <span v-else-if="item.account_status==19">{{$t("bank_card.rejected")}}</span>
            <span v-else>-</span>
          </div>
          <div class="c_right_t1 c_right_t2">
            {{ $t("main.text593") }}
            <span>$ {{ set_num3_2(item.balance * 1) }}</span>
            <img
              class="refresh_icon"
              v-if="[3, 4, 5].includes(item.status)"
              @click="refresh_btn"
              src="../assets/img/refresh_img.png"
              alt=""
            />
          </div>
          <!-- <div class="c_right_t2">
            <span>$ {{ set_num3_2(item.balance * 1) }}</span>
            <img
              class="refresh_icon"
              v-if="[3, 4, 5].includes(item.status)"
              @click="refresh_btn"
              src="../assets/img/refresh_img.png"
              alt=""
            />
          </div> -->

          <!-- *** can_active 1可以激活 0不可以激活 -->
          <!-- item.op_status == 10 -->
          <div>
            <el-button
              class="login_btn"
              v-if="item.op_status == 10"
              @click="c_act_btn(item.id, item.kit_number)"
              >{{ $t("main.text692") }}</el-button
            >

            <el-button
              class="login_btn width_css"
              v-if="item.new_status == 2"
              @click="
                get_top_up_config(item.id, item.block_orgin, item.card_id)
              "
              >{{ $t("main.text626") }}</el-button
            >
            <el-button
              class="login_btn width_css"
              v-if="[2, 3].includes(item.new_status)"
              @click="reset_pin_btn(item.id, item.block_orgin, item.op_status)"
              >{{ $t("main.text705") }}</el-button
            >
            <el-button
              class="login_btn width_css"
              v-if="[2, 3, 4, 5].includes(item.new_status)"
              @click="
                transaction_list_btn(item.card_id, item.active_time, item.number)
              "
              >{{ $t("main.text270") }}</el-button
            >

            <!-- 返回字段 new_status -- Inactive、Active、Blocked、Cancelled 、Expired 1/2/3/4/5 只有 2 Active 可以 进行 冻结 换卡操作 -->

            <el-button
              class="login_btn width_css"
              v-if="item.new_status == 2"
              @click="open_freeze_dlg(item.card_id)"
              >{{ $t("beth_text.Block_Card") }}</el-button
            >

            <!-- 1商家冻结；2Admin冻结； 3用户冻结 -->
            <!-- 解冻的时候 block_orgin 为3 BETH才可以解冻，后台 商家冻结的BETH解冻不了 -->
            <el-button
              class="login_btn width_css"
              v-if="item.new_status == 3"
              @click="
                open_unfreeze_dlg(
                  item.card_id,
                  item.block_orgin,
                  item.op_status
                )
              "
              >{{ $t("bank_card.thaw") }}</el-button
            >

            <!-- op_status 运营状态1Pending; 2KYC Processing; 3KYC Approved;  4Rejected; 5Card Binded；6Activated； 7Printing; 8block; 9Cancelled；10 mailed； 11卡异常；13 申请补卡；14补卡中；15已补卡；16 Consolidating；17Pending Rebind; 18Cancelling
            运营状态 补卡后 op_status 变为 14 to replace -->
            <el-button
              class="login_btn width_css"
              style="background: #de6763; border-color: #de6763"
              v-if="item.new_status == 2"
              @click="open_replace_card_dlg(item.card_id, item.username)"
              >{{ $t("beth_text.Replace_Card") }}</el-button
            >
            <!-- <a href="/renew?card_id=5ce26a3b24754c0da3fbf833a49caf89">XXX</a> -->
            <!-- 续费的逻辑先不更新 2023-09-27 -->
            <el-button
              class="login_btn width_css bgc_yellow"
              v-if="[2].includes(item.new_status)"
              @click="renew_btn(item)"
              >{{ $t("beth_text.renew") }}</el-button
            >
          </div>

          <el-button
            class="b_status_btn"
            :class="
              [3, 4, 5].includes(item.new_status) ? 'b_status_btn_red' : ''
            "
            size="mini"
          >
            <span v-if="item.new_status == 1">{{
              $t("bank_card.forbidden")
            }}</span>
            <span v-else-if="item.new_status == 2">{{
              $t("main.text588")
            }}</span>
            <span v-else-if="item.new_status == 3">{{
              $t("main.text589")
            }}</span>
            <span v-else-if="item.new_status == 4">{{
              $t("bank_card.Cancelled")
            }}</span>
            <span v-else-if="item.new_status == 5">{{
              $t("beth_text.Expired")
            }}</span>
          </el-button>
        </div>
      </div>
    </div>

    <!-- 购买卡片 -->
    <el-dialog
      :title="$t('main.text511')"
      :visible.sync="apply_card_dlg"
      custom-class="dlg element_input card_dlg"
      append-to-body
      width="480px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <div class="card_dlg_t1">
            <img class="card_img1" src="../assets/img/user2.png" alt="" />
            <div class="card_dlg_t2">{{ $t("main.text497") }}</div>
          </div>

          <div class="card_dlg_t1 c_radio_box">
            <div class="list_table">
              <el-radio-group v-model="check_num" @change="checkbox_fun">
                <el-radio label="1">{{ $t("main.text498") }}</el-radio>
                <el-radio label="2">{{ $t("main.text499") }}</el-radio>
              </el-radio-group>
            </div>
          </div>

          <el-form v-show="check_num == 1">
            <el-form-item>
              <el-select
                v-model="select_num"
                :placeholder="$t('main.text500')"
                @change="select_fun"
              >
                <el-option
                  v-for="(item, index) in select_list"
                  :key="index"
                  :label="item.name"
                  :value="item.director_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="btn_card">
            <el-button
              type="primary"
              class="confirm_btn confirm_btn_card"
              @click="continue_btn"
              >{{ $t("main.text394") }}</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- ------- -->

    <!-- 第一次充值信息 弹框 -->
    <el-dialog
      :title="$t('main.text633')"
      :visible.sync="first_top_up_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      center
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <!-- <div class="top_text2">{{$t('main.text634')}}</div> -->
            <!-- 年费，卡费，激活卡的费用 如果扣除过了就不需要展示了
            手续费是每次都会展示的
            最大最小充值也需要都展示吧 -->
            <div class="info_1" v-if="top_up_config.annual_fee_status == 0">
              <div class="info_1_left">{{ $t("main.text503") }}</div>
              <div class="info_1_right">{{ top_up_config.annual_fee }}</div>
            </div>
            <div class="info_1" v-if="top_up_config.card_cost_status == 0">
              <div class="info_1_left">{{ $t("main.text504") }}</div>
              <div class="info_1_right">{{ top_up_config.card_cost }}</div>
            </div>
            <!-- 激活卡的费用 -->
            <div
              class="info_1"
              v-if="top_up_config.card_activation_status == 0"
            >
              <div class="info_1_left">{{ $t("main.text644") }}</div>
              <div class="info_1_right">
                {{ top_up_config.card_activation }}
              </div>
            </div>
            <!-- 手续费 -->
            <div class="info_1">
              <div class="info_1_left">{{ $t("main.text645") }}</div>
              <div class="info_1_right">{{ top_up_config.load_fee }}</div>
            </div>
            <div class="info_1">
              <div class="info_1_left">{{ $t("main.text635") }}</div>
              <div class="info_1_right">{{ top_up_config.min_top_up }}</div>
            </div>
            <!-- <div class="info_1">
              <div class="info_1_left">{{$t('main.text636')}}</div>
              <div class="info_1_right">{{top_up_config.max_top_up}}</div>
            </div> -->
            <!-- 转换费 -->
            <div class="info_1" v-if="top_up_config.top_up_fee_method == 1">
              <div class="info_1_left">{{ $t("main.btext695") }}</div>
              <div class="info_1_right">
                <!-- {{ set_num_fee(rateConfig.USDTUSD) }} -->
                {{ top_up_config.usdt_usd_rate }}
              </div>
            </div>
            <div class="info_1" v-if="top_up_config.top_up_fee_method == 1">
              <div class="info_1_left">{{ $t("main.btext696") }}</div>
              <div class="info_1_right">
                <!-- {{ set_num_fee(rateConfig.USDCUSD) }} -->
                {{ top_up_config.usdc_usd_rate }}
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="first_top_up_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="first_top_up_next"
          class="confirm_btn"
        >
          {{ $t("main.text394") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 激活 填信息 弹框 -->
    <el-dialog
      :title="$t('main.text627')"
      :visible.sync="card_activate_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      center
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <!-- <div class="top_text">{{$t('main.text628')}}</div> -->
            <!-- <el-form-item :label="$t('main.text629')">
              <el-input v-model="card_digits"></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('main.text630')">
              <el-input v-model="card_id"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="card_activate_dlg = false" class="cancel_btn">
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="card_activate_submit"
          class="confirm_btn"
        >
          {{ $t("main.text394") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 激活成功 弹框 -->
    <el-dialog
      :visible.sync="card_activate_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img style="width: 35px" src="../assets/img/dui_icon.png" alt="" />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text685") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text686") }}
        {{ card_number ? card_number.substr(12, 4) : "" }}
        {{ $t("main.text686_r") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="card_activate_ok_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 充值 弹框 -->
    <el-dialog
      :title="$t('main.text626')"
      :visible.sync="top_up_dlg"
      custom-class="dlg element_input add_dlg top_up_dlg"
      append-to-body
      center
      top="5vh"
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text2">{{ $t("main.text637") }}</div>
            <div class="top_text3">{{ $t("main.text638") }}</div>
            <div class="amount_box">
              <div class="top_text4">{{ $t("main.text389") }}</div>
              <div class="top_text5 min_max_box">
                <div>
                  {{ $t("main.text650") }} ${{
                    dispose_num(top_up_config.min_top_up)
                  }}
                </div>
                <div>
                  {{ $t("top_up_dlg.Max_per") }} ${{
                    dispose_num(top_up_config.max_top_up)
                  }}
                </div>
              </div>
              <div class="top_text5">
                {{ $t("top_up_dlg.Current_Cap") }}${{
                  set_num3(top_up_config.now_balance_limit)
                }}
              </div>

              <div class="zdy_input box_margin">
                <!-- @input="input3_set" -->
                <el-input
                  v-model="input_v3_set"
                  placeholder=""
                  @blur="input3_set"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3').replace(/^\./g, '')"
                ></el-input>
                <div class="top_text7_2">USD</div>
              </div>

              <!-- 充值数量超过充值限额 警示框 红色 -->
              <div class="warning_red warning_yellow" v-show="warning_red_show">
                <div class="warning_red_icon warning_yellow_icon">
                  <i class="el-icon-warning"></i>
                </div>
                <div class="warning_red_text warning_yellow_text">
                  {{ $t("top_up_dlg.P_may") }}
                </div>
              </div>
              <!-- 余额不足  警示框 黄色 -->
              <!-- <div class="warning_red warning_yellow" v-show="warning_yellow_show">
                <div class="warning_red_icon warning_yellow_icon"><i class="el-icon-warning"></i></div>
                <div class="warning_red_text warning_yellow_text">
                  {{$t('main.text655')}}
                  {{select3}}
                  {{$t('main.text655_2')}}
                  <div>
                    <router-link :to="{ path: '/blockchain_d/deposit' }" class="top_up_link">{{$t('main.text656')}}</router-link>
                  </div>
                </div>
              </div> -->

              <div class="top_text4 top_text6">{{ $t("main.text741") }}</div>
              <!-- <div class="top_text7" v-show="usdt_num_show">USD {{usdt_num*1}}</div> -->
              <div class="top_text7">
                <el-popover
                  width="170"
                  popper-class="bz_pop"
                  v-model="visible3"
                  trigger="click"
                >
                  <div slot="reference" class="type_box">
                    <div class="type_box1">
                      <img :src="set_name_img(select3)" alt="" />
                      <div class="type_box2">{{ select3 }}</div>
                    </div>
                    <div class="type_box3">
                      <i class="el-icon-caret-bottom"></i>
                    </div>
                  </div>
                  <div class="bz_list">
                    <div
                      class="type_box1 bz_list1"
                      v-for="(item, index) in currency_list3"
                      :key="index"
                      @click="select3_fun(item)"
                    >
                      <img :src="set_name_img(item)" alt="" />
                      <div class="type_box2">{{ item }}</div>
                    </div>
                  </div>
                </el-popover>
                <div class="div_num">{{ result_num * 1 }}</div>
              </div>

              <div class="top_text5 top_text5_2">
                {{ $t("main.text652") }}
                <span class="top_text10" v-if="select3 == 'BTC'"
                  >BTC = {{ set_num3(top_up_details.btc_balance) }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'ETH'"
                  >ETH = {{ set_num3(top_up_details.eth_balance) }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'USDT'"
                  >USDT = {{ set_num3(top_up_details.usdt_balance) }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'USDC'"
                  >USDC = {{ set_num3(top_up_details.usdc_balance) }}</span
                >
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text742") }}{{ select3 }} = {{ amount_crypto }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text743") }}{{ select3 }} = {{ fee_crypto_amount }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text744") }}{{ select3 }} =
                {{ total_crypto_amount }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text745") }}= {{ afterBalance }}
              </div>
            </div>
            <div>
              <div class="top_text4 top_text6">
                {{ $t("main.text514") }} ({{
                  top_up_config.contract_card_name
                }})
              </div>
              <div class="top_text8">
                <div class="top_text9">{{ $t("main.text567") }}</div>
                <div class="top_text10">{{ top_up_details.card_name }}</div>
              </div>
              <div class="top_text8">
                <div class="top_text9">{{ $t("main.text658") }}</div>
                <div class="top_text10">
                  {{
                    top_up_details.number
                      ? "****" + top_up_details.number.substr(-4)
                      : "-"
                  }}
                </div>
              </div>
              <div class="top_text8">
                <div class="top_text9">
                  {{ $t("main.text255") }}
                  <!-- <br/>({{$t('main.text659')}} = {{top_up_details.card_limit}}) -->
                </div>
                <div class="top_text10">USD {{ top_up_details.balance }}</div>
              </div>
            </div>

            <div>
              <div class="top_text4 top_text6">
                {{ $t("top_up_dlg.Source_fund") }}
              </div>
              <div class="top_text8">
                <el-select v-model="t_up_select" style="width: 100%">
                  <el-option
                    :label="$t('top_up_dlg.E_Income')"
                    value="Employment Income"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.I_Income')"
                    value="Investment Income"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.B_Income')"
                    value="Business Income"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Savings')"
                    value="Savings"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Loans')"
                    value="Loans"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Sales_I')"
                    value="Sales of Investment"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Gifts')"
                    value="Gifts"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Others')"
                    value="Others"
                  ></el-option>
                </el-select>
              </div>
              <div class="top_text4 top_text6" v-if="t_up_select == 'Others'">
                {{ $t("top_up_dlg.Others") }}
              </div>
              <div class="top_text8" v-if="t_up_select == 'Others'">
                <el-input
                  v-model="t_up_others"
                  placeholder=""
                  style="width: 100%"
                ></el-input>
              </div>
              <div class="top_text8">
                <el-checkbox v-model="read_protocol" class="tup_checkbox">
                  {{ $t("top_up_dlg.I_confirm") }}
                </el-checkbox>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="top_up_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button type="primary" @click="top_up_submit" class="confirm_btn">
          {{ $t("main.text394") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 充值成功 弹框 -->
    <el-dialog
      :visible.sync="top_up_success_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
      @close="go_list"
    >
      <div class="log_out1">
        <img style="width: 35px" src="../assets/img/dui_icon.png" alt="" />
      </div>
      <div class="log_out2 padding1">
        {{ t_up_title }}
      </div>
      <div class="log_out3 padding2">
        {{ t_up_msg }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="top_up_success_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 充值失败 弹框 -->
    <el-dialog
      :visible.sync="top_up_error_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img style="width: 35px" src="../assets/img/error_icon.png" alt="" />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text641") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text642") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="reset_btn"
          @click="top_up_error_dlg = false"
          >{{ $t("main.text7") }}</el-button
        >
        <el-button type="primary" class="apply_btn" @click="card_topUp_fun">{{
          $t("main.text643")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 重置联名卡密码 弹框 -->
    <el-dialog
      :title="$t('main.text705')"
      :visible.sync="reset_pwd_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      center
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <el-form-item :label="$t('main.text706')">
              <el-input
                v-model="new_pin"
                :type="pwdType == true ? 'password' : 'text'"
                oninput="value=value.replace(/[^0-9]/g,'')"
                maxlength="4"
              ></el-input>
              <span class="show-pwd" @click="pwdType = !pwdType">
                <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
              </span>

              <div class="btm_text2">{{ $t("main.text707") }}</div>
            </el-form-item>
            <el-form-item :label="$t('main.text708')">
              <el-input
                v-model="confirm_new_pin"
                :type="pwdType2 == true ? 'password' : 'text'"
                oninput="value=value.replace(/[^0-9]/g,'')"
                maxlength="4"
              ></el-input>
              <span class="show-pwd" @click="pwdType2 = !pwdType2">
                <img :src="pwdType2 ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="reset_pwd_dlg = false" class="cancel_btn">
          {{ $t("main.text7") }}
        </el-button>
        <el-button type="primary" @click="reset_pwd_submit" class="confirm_btn">
          {{ $t("main.text130") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- ------ -->
    <!-- 冻结卡 弹框 -->
    <el-dialog
      :visible.sync="freeze_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 50px"
          src="../assets/img/sj_warning_img.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("beth_text.Block_Card") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("beth_text.Confirmed_freezing") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="reset_btn"
          @click="freeze_dlg = false"
          >{{ $t("main.text7") }}</el-button
        >
        <el-button
          type="primary"
          class="apply_btn"
          @click="freeze_dlg_confirm"
          >{{ $t("main.text130") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 解冻卡 弹框 -->
    <el-dialog
      :visible.sync="unfreeze_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 50px"
          src="../assets/img/sj_warning_img.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("bank_card.thaw") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("beth_text.Confirmed_thawing") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="reset_btn"
          @click="unfreeze_dlg = false"
          >{{ $t("main.text7") }}</el-button
        >
        <el-button
          type="primary"
          class="apply_btn"
          @click="unfreeze_dlg_confirm"
          >{{ $t("main.text130") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- Replace Card 弹框 -->
    <el-dialog
      :title="$t('beth_text.Replace_Card')"
      :visible.sync="replace_card_dlg"
      custom-class="dlg element_input add_dlg replace_dlg_posi"
      append-to-body
      center
      width="640px"
    >
      <div class="dlg_body rep_form_top">
        <div class="d_body">
          <el-form class="dlg_form2 rep_form" label-position="top">
            <div class="rep_title">
              {{ $t("beth_text.Reason_replacement") }}
            </div>
            <el-form-item>
              <div class="radio_row">
                <el-radio v-model="op_cause_type" label="1">{{
                  $t("beth_text.Card_loss")
                }}</el-radio>
                <div class="radio_btm_txt">
                  <!-- <div>确认冻结该卡并支付补卡费{{replace_card_data.card_replace_fee ||"" }} USDC/T,此操作不可撤销。</div> -->
                  <div>
                    {{
                      $t("beth_text.Confirm_to_freeze", {
                        fee: replace_card_data.card_replace_fee || "",
                      })
                    }}
                  </div>
                  <div>{{ $t("beth_text.address_accurate") }}</div>
                </div>
              </div>
              <div class="radio_row">
                <el-radio v-model="op_cause_type" label="4">{{
                  $t("beth_text.Card_damage")
                }}</el-radio>
                <div class="radio_btm_txt">
                  <div>
                    {{
                      $t("beth_text.Confirm_to_freeze", {
                        fee: replace_card_data.card_replace_fee || "",
                      })
                    }}
                  </div>
                  <div class="mbtm">{{ $t("beth_text.address_accurate") }}</div>

                  <!-- <div>{{$t('beth_text.Not_sure_card')}}</div> -->
                  <div>
                    {{ $t("beth_text.Not_sure_card") }}
                    <span
                      class="replace_txt_click"
                      @click="open_freeze_dlg(operate_id)"
                      >{{ $t("beth_text.Temporarily_block_it") }}</span
                    >
                    {{ $t("beth_text.Temporarily_block_it_btm") }}
                  </div>
                  <div class="mbtm">{{ $t("beth_text.card_recovered") }}</div>

                  <div>{{ $t("beth_text.Whether_damaged") }}</div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="dlg_body rep_form_btm">
        <div class="d_body">
          <el-form class="dlg_form2 rep_form" label-position="top">
            <div class="rep_title">
              {{ $t("beth_text.Mailing_address_accurate") }}
            </div>
            <el-form-item :label="$t('bank_card.Mail_Address_Line')">
              <el-input v-model="replace_card_data.address"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.Mail_Address_Line2')">
              <el-input
                v-model="replace_card_data.secondary_address"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.Mail_City')">
              <el-input v-model="replace_card_data.city"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.Mail_State')">
              <el-input v-model="replace_card_data.state"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bank_card.Mail_Country')">
              <el-input v-model="replace_card_data.country"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text199')">
              <div class="form_p_1">
                <el-select
                  class="form_p_2"
                  filterable
                  v-model="replace_card_data.calling_code"
                  placeholder=" "
                >
                  <div v-for="(item, name) in code_json" :key="name">
                    <el-option
                      v-for="(item, index) in item"
                      :key="index"
                      :label="item.name + '-' + item.num"
                      :value="item.num"
                    >
                    </el-option>
                  </div>
                </el-select>
                <el-input
                  class="form_p_3"
                  v-model="replace_card_data.mobile_number"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="replace_card_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="replace_card_dlg_confirm"
          class="confirm_btn"
        >
          {{ $t("main.text130") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { card_calc } from "@/api/api";
import {
  card_audit,
  card_getTopUpConfig,
  card_active,
  card_topUp,
  card_refreshData,
  setPin,
} from "@/api/api";
import { card_block, card_unblock, replace, getReplaceConfig } from "@/api/api";
import { home } from "@/api/api";
import BigNumber from "bignumber.js";
// import { debounce } from "@/utils/util.js";

export default {
  data() {
    return {
      apply_card_dlg: false,
      card_fee_dlg: false,
      check_num: "1",
      select_num: "",
      select_list: [],
      director_id: "",
      feb_config: {},
      feb_link: "",
      company_name: "",
      kyc_status: "",
      u_id: sessionStorage.getItem("userid"),

      card_activate_dlg: false,
      card_digits: "",
      card_id: "",
      card_activate_6_dlg: false,
      card_activate_ok_dlg: false,

      top_up_dlg: false,
      // ------
      card_reason: "",
      card_reason_no_id: "",

      form: {
        content: "",
        time: "",
        status: "",
      },

      visible3: false,
      select3: "USDT",
      input_v3: "",
      input_v3_set: "",
      inp3_ratio: "",

      // currency_list3:["BTC","ETH","USDT","USDC"],
      currency_list3: ["USDT", "USDC"],

      // 币种 图标
      icon_list: {
        ETH: require("../assets/img/ETH.png"),
        USDT: require("../assets/img/USDT.png"),
        BTC: require("../assets/img/BTC.png"),
        USDC: require("../assets/img/USDC.png"),
        USD: require("../assets/img/USD.png"),
        CNY: require("../assets/img/CNY.png"),
        SGD: require("../assets/img/SGD.png"),
        GBP: require("../assets/img/GBP.png"),
        AUD: require("../assets/img/AUD.png"),
        HKD: require("../assets/img/HKD.png"),
      },
      top_up_success_dlg: false,
      top_up_error_dlg: false,
      top_up_config: "",
      top_up_id: "",
      activate_card_id: "",
      top_up_details: "",
      rateConfig: "",
      usdt_num: "",
      usdt_num_show: false,
      account_num: "",
      warning_red_show: false,
      warning_yellow_show: false,

      card_list: [],
      first_top_up_dlg: false,
      card_number: "",
      result_num: "",

      reset_pwd_dlg: false,
      new_pin: "",
      confirm_new_pin: "",
      reset_pin_id: "",

      pwd_yes: require("../assets/img/eye_no_b.png"),
      pwd_no: require("../assets/img/eye_yes_b.png"),
      pwdType: true,
      pwdType2: true,
      amount_crypto: 0,
      fee_crypto_amount: 0,
      total_crypto_amount: 0,
      afterBalance: 0,

      freeze_dlg: false,
      unfreeze_dlg: false,
      // unfreeze_no_dlg:false,
      replace_card_dlg: false,
      op_cause_type: "1", // 1丢失失窃；none 3用户损坏；4工厂损坏；
      rep_addr: "",
      card_set_checked: true,
      operate_id: "",
      replace_card_data: {},
      code_json: "",
      FirstPin: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      replace_card_username: "",

      t_up_select: "",
      t_up_others: "",
      read_protocol: false,
      deposit_amount: "", //充值数量
      t_up_title: "",
      t_up_msg: "",
    };
  },
  created() {
    if (this.v_lan == "ch") {
      this.code_json = require("@/assets/phone_code/num_area_ch2.json");
    } else {
      this.code_json = require("@/assets/phone_code/num_area_en2.json");
    }
    if (this.code_json) {
      let cityName = {};
      //循环26个字母的数组
      this.FirstPin.forEach((item) => {
        cityName[item] = [];
        this.code_json.forEach((el) => {
          //对比开头字母是否对应
          // 做一个判断 中文时候不走
          let first = el.py.substring(0, 1).toUpperCase();
          if (first == item) {
            cityName[item].push(el);
          }
        });
      });
      // console.log(cityName)
      this.$nextTick(() => {
        this.code_json = cityName;
        // console.log(this.code_json);
      });
    }
  },
  mounted() {
    // this.get_fee_api();
    this.get_list();
  },
  methods: {
    dispose_num(v) {
      if (v) {
        return this.set_num3(parseFloat(v.replace(/[^\d\\.-]/g, "")));
      }
    },
    set_num_fee(v) {
      let d = BigNumber(1).minus(v).times(100);
      return d + "%";
    },
    // card_dlg_open(){
    //     // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
    //     if(this.kyc_status&&this.kyc_status!=4){
    //         return this.message.ismessage("error",this.$t('main.text599'));
    //     }

    //     this.apply_card_dlg=true;
    //     this.select_num='';
    //     // 卡片类型 1 FEB Debit Card 2 BETH Debit Card
    //     localStorage.setItem("card_type",'1');
    //     getDirectorList().then(res=>{
    //         if(res.data.code==200){
    //             // console.log(res.data.data);
    //             this.select_list=res.data.data;
    //         }else{
    //             this.message.ismessage('error',res.data.msg);
    //         }
    //     })
    // },
    select_fun(id) {
      // console.log(id);
      this.director_id = id;
      let select_data = {};
      for (let i = 0; i < this.select_list.length; i++) {
        if (this.select_list[i].director_id == id) {
          select_data = this.select_list[i];
        }
      }
      // console.log(select_data);

      localStorage.setItem("director_data", JSON.stringify(select_data));
    },
    checkbox_fun(v) {
      v;
      // console.log(v);
    },
    continue_btn() {
      if (this.check_num == 1) {
        if (!this.select_num) {
          this.message.ismessage("error", this.$t("main.text500"));
          return false;
        }
        // 股东跳转
        // occupation	Number	1 Director 2 Staff
        // director_id	Number	director信息列表 里的 director_id
        localStorage.setItem("occupation_type", "1");
        localStorage.setItem("director_id", this.director_id);
        this.$router.push({ path: "/apply_card_input", query: { type: "1" } });
      } else {
        // 普通员工跳转
        localStorage.setItem("occupation_type", "2");
        localStorage.setItem("director_id", "");
        this.$router.push({ path: "/apply_card_input", query: { type: "2" } });
      }
    },
    // card_fee_btn(){
    //     this.card_fee_dlg=true;
    // },
    // get_fee_api(){
    //     card_getConfig().then(res=>{
    //         if(res.data.code==200){
    //             this.feb_config=res.data.data.feb_config;
    //             this.feb_link=res.data.data.feb_link;
    //             this.company_name=res.data.data.company_name;
    //             console.log(res.data.data);
    //             this.card_fee_dlg=true;
    //             // console.log(this.feb_config);
    //         }else{
    //             this.message.ismessage('error',res.data.msg);
    //         }
    //     })
    // },
    copy_link() {
      // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
      if (this.kyc_status && this.kyc_status != 4) {
        return this.message.ismessage("error", this.$t("main.text599"));
      }
      let Base64 = require("js-base64").Base64;
      //或者import {Base64} from 'js-base64'
      // Base64.encode(password);//加密
      // Base64.decode(password);//解密
      if (this.u_id && typeof this.u_id == "string") {
        let u_id = Base64.encode(this.u_id);
        let v_lan = "";
        if (this.v_lan == "ch") {
          v_lan = "ch";
        } else if (this.v_lan == "jp") {
          v_lan = "jp";
        } else {
          v_lan = "en";
        }

        let str = `${this.feb_link}?userid-${u_id}&lang-${Base64.encode(
          v_lan
        )}&company_name-${encodeURIComponent(
          Base64.encode(this.company_name)
        )}`;
        this.copy_api(str);
      }
    },
    //复制
    copy_api(v) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", v);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      this.message.ismessage("success", this.$t("main.text297"));
      // this.$message.success("复制成功");
    },

    // ------
    // 通过
    card_reason_ok_fun(id) {
      card_audit({
        id: id,
        status: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.card_reason_ok_dlg = true;
          this.get_list();
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    // 拒绝
    card_reason_no_fun(id) {
      this.card_reason_no_dlg = true;
      this.card_reason_no_id = id;
      // console.log(id);
    },
    // 拒绝 弹框 确定按钮
    no_btn() {
      if (!this.card_reason) {
        return this.message.ismessage("error", this.$t("main.text598"));
      }
      // id	Number	记录ID
      // status	Number	0拒绝 1通过
      // reason_ch	String	中文拒绝理由
      // reason_en	String	中文拒绝理由
      // reason_jp	String	中文拒绝理由
      let r_ch = "";
      let r_en = "";
      let r_jp = "";
      if (this.v_lan == "ch") {
        r_ch = this.card_reason;
        r_en = "";
        r_jp = "";
      } else if (this.v_lan == "jp") {
        r_ch = "";
        r_en = "";
        r_jp = this.card_reason;
      } else {
        r_ch = "";
        r_en = this.card_reason;
        r_jp = "";
      }

      card_audit({
        id: this.card_reason_no_id,
        status: 0,
        reason_ch: r_ch,
        reason_en: r_en,
        reason_jp: r_jp,
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage("success", res.data.msg);
          this.card_reason_no_dlg = false;
          this.get_list();
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },

    reset_btn() {
      this.form.time = "";
      this.form.content = "";
      this.form.status = "";
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    apply_btn() {
      // console.log(this.form);
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    activate_btn(id) {
      this.card_digits = "";
      this.card_id = "";
      this.card_activate_dlg = true;
      this.activate_card_id = id;
      // console.log(this.activate_card_id);
    },
    c_act_btn(id, c_num) {
      this.activate_card_id = id;
      this.card_number = c_num;
      this.card_activate_dlg = true;
    },
    card_activate_submit() {
      // if(!this.card_digits.trim()||this.card_digits.length !== 16){
      //     return this.message.ismessage('error',this.$t('main.text660'));
      // }
      if (!this.card_id.trim()) {
        return this.message.ismessage("error", this.$t("main.text661"));
      }
      card_active({
        id: this.activate_card_id,
        // kit_number:this.card_digits,
        // number:this.card_digits,
        card_id: this.card_id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage("success", res.data.msg);
          this.card_activate_dlg = false;
          this.card_activate_ok_dlg = true;
          this.get_list();
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    first_top_up_next() {
      this.first_top_up_dlg = false;
      this.top_up_dlg = true;
      this.input_v3 = "";
      this.input_v3_set = "";
      this.usdt_num_show = false;
      this.warning_red_show = false;
      this.warning_yellow_show = false;
      this.t_up_select = "";
      this.t_up_others = "";
      this.read_protocol = false;
    },
    top_up_submit() {
      if (!this.input_v3.trim()) {
        return this.message.ismessage("error", this.$t("main.text389"));
      }
      // if (this.usdt_num <= this.account_num) {
      //     return this.message.ismessage('error',this.$t('main.text662'));
      // }

      // if((this.input_v3)*1 > ((this.top_up_config.max_top_up).substr(1))*1){
      //     return this.warning_red_show=true;
      // }else{
      //     this.warning_red_show=false;
      // }

      // select3== BTC 'ETH' USDT USDC
      // if(this.select3=="BTC"){
      //     if((this.input_v3)*1 > this.top_up_details.btc_balance){
      //     return this.warning_yellow_show=true;
      //     }else{
      //     this.warning_yellow_show=false;
      //     }
      // }else if(this.select3=="ETH"){
      //     if((this.input_v3)*1 > (this.top_up_details.eth_balance)*1){
      //     return this.warning_yellow_show=true;
      //     }else{
      //     this.warning_yellow_show=false;
      //     }
      // }else if(this.select3=="USDT"){
      //     if((this.input_v3)*1 > (this.top_up_details.usdt_balance)*1){
      //     return this.warning_yellow_show=true;
      //     }else{
      //     this.warning_yellow_show=false;
      //     }
      // }else if(this.select3=="USDC"){
      //     if((this.input_v3)*1 > (this.top_up_details.usdc_balance)*1){
      //     return this.warning_yellow_show=true;
      //     }else{
      //     this.warning_yellow_show=false;
      //     }
      // }

      // if (this.usdt_num < (this.top_up_config.min_top_up).substr(1)*1) {
      //     return this.message.ismessage('error',this.$t('main.text663'));
      // }
      // if (this.usdt_num > (this.top_up_config.max_top_up).substr(1)*1) {
      //     return this.message.ismessage('error',this.$t('main.text664'));
      // }

      this.card_topUp_fun();
    },
    card_topUp_fun() {
      if (!this.t_up_select) {
        return this.message.ismessage(
          "error",
          this.$t("top_up_dlg.Source_fund")
        );
      }
      let fund_source = this.t_up_select;
      if (this.t_up_select == "Others") {
        if (!this.t_up_others) {
          return this.message.ismessage("error", this.$t("top_up_dlg.Others"));
        } else {
          fund_source = this.t_up_others;
        }
      }
      if (!this.read_protocol) {
        return this.message.ismessage(
          "error",
          this.$t("top_up_dlg.Please_check")
        );
      }
      card_topUp({
        card_id: this.card_id,
        token_type: this.select3,
        amount: this.input_v3,
        fund_source,
      }).then((res) => {
        if (res.data.code == 200) {
          // this.message.ismessage('success',res.data.msg);
          this.top_up_dlg = false;
          this.get_list();
          this.t_up_title = res.data.title;
          this.t_up_msg = res.data.msg;
          this.top_up_success_dlg = true;
        } else {
          this.message.ismessage("error", res.data.msg);
          this.top_up_error_dlg = true;
        }
      });
    },
    input3_set(e) {
      let v = e.target.value;
      this.input_v3 = v;
      this.input_v3_set = this.set_num3_2(v * 1);
      this.set_usd_num(v);
    },
    select3_fun(v) {
      this.select3 = v;
      this.visible3 = false;
      if (this.input_v3) {
        this.set_usd_num(this.input_v3);
      }
    },
    set_name_img(v) {
      if (v.indexOf("-") != -1) {
        let str1 = v.split("-")[0];
        return this.icon_list[str1];
      } else {
        return this.icon_list[v];
      }
    },
    // 设置key 对应接口 key
    set_api_key(v) {
      if (v.indexOf("-") != -1) {
        return v.toLowerCase().replace("-", "_");
      } else {
        return v.toLowerCase();
      }
    },
    get_top_up_config(id, block_orgin, card_id) {
      if ([1, 2].includes(block_orgin)) {
        return this.message.ismessage(
          "error",
          this.$t("beth_text.card_administrator")
        );
      }
      this.top_up_id = id;
      this.card_id = card_id;
      // 获取充值配置
      card_getTopUpConfig({ card_id }).then((res) => {
        if (res.data.code == 200) {
          // console.log(res.data);
          this.top_up_config = res.data.data;
          this.top_up_details = res.data.details;
          this.rateConfig = res.data.details.rateConfig;
          this.first_top_up_dlg = true;
          // console.log(this.top_up_config);
          // console.log(this.top_up_details);

          this.result_num = "";
          this.select3 = "USDT";
          this.amount_crypto = 0;
          this.fee_crypto_amount = 0;
          this.total_crypto_amount = 0;
          this.afterBalance = 0;
        }
      });
    },
    // 计算 用户输入 转换usd
    set_usd_num(v) {
      if (v) {
        if (this.input_v3 * 1 > this.top_up_config.recharge_warning * 1) {
          this.warning_red_show = true;
        } else {
          this.warning_red_show = false;
        }

        let _this = this;
        // debounce(function(){
        card_calc({
          card_id: _this.card_id,
          token_type: _this.select3,
          amount: v,
        }).then((res) => {
          if (res.data.code == 200) {
            _this.result_num = res.data.data.total_crypto_amount;
            _this.amount_crypto = res.data.data.amount_crypto;
            _this.fee_crypto_amount = res.data.data.fee_crypto_amount;
            _this.total_crypto_amount = res.data.data.total_crypto_amount;
            _this.afterBalance = res.data.data.afterBalance;
          } else {
            _this.message.ismessage("error", res.data.msg);

            _this.result_num = 0;
            _this.amount_crypto = 0;
            _this.fee_crypto_amount = 0;
            _this.total_crypto_amount = 0;
            _this.afterBalance = 0;
          }
        });
        // },1000);
      }
    },

    // ---Beth---
    get_list() {
      home().then((res) => {
        if (res.data.code == 200) {
          // this.card_list=res.data.data.card_list;
          // console.log('get_list====', this.card_list);
          const card_list = res.data.data.card_list;
          for (const item of card_list) {
            if (item.num_is_show != false) {
              item.num_is_show = false;
            }
          }
          this.card_list = card_list;
        }
      });
    },
    // 刷新
    refresh_btn() {
      card_refreshData().then((res) => {
        if (res.data.code == 200) {
          this.get_list();
          this.message.ismessage("success", this.$t("main.text673_ok"));
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    reset_pin_btn(id, block_orgin, op_status) {
      if ([1, 2].includes(block_orgin)) {
        return this.message.ismessage(
          "error",
          this.$t("beth_text.card_administrator")
        );
      }
      if (op_status == 14) {
        return this.message.ismessage(
          "error",
          this.$t("beth_text.password_cannot_changed")
        );
      }
      this.reset_pin_id = id;
      this.new_pin = "";
      this.confirm_new_pin = "";
      this.reset_pwd_dlg = true;
    },
    reset_pwd_submit() {
      if (!this.new_pin)
        return this.message.ismessage("error", this.$t("main.text705"));
      if (!this.confirm_new_pin)
        return this.message.ismessage("error", this.$t("main.text706"));
      if (this.new_pin.length < 4 || this.confirm_new_pin.length < 4)
        return this.message.ismessage("error", this.$t("main.text707"));
      if (this.new_pin !== this.confirm_new_pin)
        return this.message.ismessage("error", this.$t("main.text209"));
      setPin({
        id: this.reset_pin_id,
        pin: this.new_pin,
        confirm_pin: this.confirm_new_pin,
      }).then((res) => {
        if (res.data.code == 200) {
          this.reset_pwd_dlg = false;
          this.get_list();
          this.message.ismessage("success", this.$t("main.text215"));
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    transaction_list_btn(id, active_time, number) {
      this.$router.push({
        path: "/transaction_record",
        query: { id: id, time: active_time, number: number },
      });
    },
    // ------
    open_freeze_dlg(id) {
      this.operate_id = id;
      this.freeze_dlg = true;
    },
    async freeze_dlg_confirm() {
      const res = await card_block({ card_id: this.operate_id });
      if (res.data.code != 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.message.ismessage("success", this.$t("beth_text.Freezing_success"));
      this.freeze_dlg = false;
      this.get_list();
    },
    open_unfreeze_dlg(id, block_orgin, op_status) {
      // 解冻的 时候 status 为6 block_orgin 为3 BETH才可以解冻，后台 商家冻结的BETH解冻不了
      this.operate_id = id;
      if (op_status == 14) {
        return this.message.ismessage(
          "error",
          this.$t("beth_text.applied_replacement_card")
        );
      }
      if (block_orgin == 3) {
        this.unfreeze_dlg = true;
      } else {
        if ([1, 2].includes(block_orgin)) {
          return this.message.ismessage(
            "error",
            this.$t("beth_text.card_frozen_administrator")
          );
        }
      }
    },
    async unfreeze_dlg_confirm() {
      const res = await card_unblock({ card_id: this.operate_id });
      if (res.data.code != 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.message.ismessage(
        "success",
        this.$t("bank_card.Successful_thawing")
      );
      this.unfreeze_dlg = false;
      this.get_list();
    },
    async open_replace_card_dlg(id, username) {
      this.replace_card_username = username;
      this.operate_id = id;
      await this.get_card_config();
      this.replace_card_data && (this.replace_card_dlg = true);
    },
    async replace_card_dlg_confirm() {
      if (!this.replace_card_data.address) {
        return this.message.ismessage("error", this.$t("main.text554"));
      }
      if (!this.replace_card_data.city) {
        return this.message.ismessage("error", this.$t("main.text557"));
      }
      if (!this.replace_card_data.state) {
        return this.message.ismessage("error", this.$t("main.text556"));
      }
      if (!this.replace_card_data.country) {
        return this.message.ismessage("error", this.$t("main.text555"));
      }
      if (!this.replace_card_data.calling_code) {
        return this.message.ismessage("error", this.$t("main.text574"));
      }
      if (!this.replace_card_data.mobile_number) {
        return this.message.ismessage("error", this.$t("main.text551"));
      }
      // username:this.replace_card_username,
      const res = await replace({
        card_id: this.operate_id,
        op_cause_type: this.op_cause_type,
        mail_address: this.replace_card_data.address,
        mail_secondary_address: this.replace_card_data.secondary_address,
        mail_city: this.replace_card_data.city,
        mail_state: this.replace_card_data.state,
        mail_country: this.replace_card_data.country,
        mail_postal_code: this.replace_card_data.postal_code,
        mail_mobile_number: this.replace_card_data.mobile_number,
        mail_calling_code: this.replace_card_data.calling_code,
      });
      if (res.data.code != 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.message.ismessage(
        "success",
        this.$t("beth_text.Card_replacement_success")
      );
      this.replace_card_dlg = false;
      this.get_list();
    },
    async get_card_config() {
      const res = await getReplaceConfig({ card_id: this.operate_id });
      if (res.data.code != 200) {
        this.replace_card_data = {};
        return this.message.ismessage("error", res.data.msg);
      }
      this.replace_card_data = res.data.data;
    },
    renew_btn(item) {
      if (item.new_status == 3 && [1, 2].includes(item.block_orgin)) {
        return this.message.ismessage(
          "error",
          this.$t("beth_text.card_administrator")
        );
      }
      this.$router.push({ path: "/renew", query: { card_id: item.card_id } });
    },
    go_list(){
      this.$router.push("/top_up_history");
    },
  },
};
</script>

<style scoped>
.cord_num {
  z-index: 2;
  position: relative;
}
.card_bgc {
  width: 100%;
  position: relative;
}
.cardBg img {
  width: 40%;
  position: absolute;
  right: 20px;
  bottom: 20px;
  z-index: 1;
  border-radius: 5px;
}
.home_tit {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 16px;
}
.card_box1 {
  border-radius: 16px;
  color: #fff;
}
.card_box1_top {
  height: 70px;
  background: #223c58;
  position: relative;
  border-radius: 16px 16px 0 0;
}
.card_box1_top_img {
  width: 90%;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.card_box1_bottom {
  background: #04182a;
  box-sizing: border-box;
  padding: 16px 28px 28px;
  border-radius: 0 0 16px 16px;
}
.btm_t1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 8px;
}
.btm_t2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.8;
  margin-bottom: 16px;
}
.btm_t3 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #deb981;
  box-sizing: border-box;
  padding: 0 32px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  cursor: pointer;
  border: 1.5px solid #deb981;
  border-radius: 4px;
  display: inline-block;
}
.card_row {
  margin: 7% 0 40px;
}
@media screen and (min-width: 1600px) {
  .card_box1_top {
    height: 85px;
  }
}
.card_info_icon {
  font-size: 18px;
  margin-left: 10px;
  cursor: pointer;
}
.c_img2 {
  border-radius: 8px 8px 0 0;
}
.btm_t3_2 {
  color: #8393a5;
  border-color: #8393a5;
}
.c2_box {
  box-sizing: border-box;
  padding: 0 13%;
}
.c2_box_t1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: #ffffff;
  opacity: 0.48;
}
.c2_box_t2 {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.04em;
  color: #ffffff;
  opacity: 0.4;
}
.card_img1 {
  width: 39px;
}
.card_dlg_t1 {
  text-align: center;
}
.card_dlg_t2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-top: 17px;
}
.confirm_btn_card,
.confirm_btn_card:hover,
.confirm_btn_card:focus,
.confirm_btn_card:active {
  min-width: 144px;
  margin-top: 12px;
}
.btn_card {
  text-align: center;
}
.dlg_body {
  border-radius: 0 0 16px 16px;
}

/* 单选框 */
.list_table .el-radio {
  color: #fff;
}
.list_table >>> .el-radio__input.is-checked + .el-radio__label {
  color: #fff;
}
.list_table >>> .el-radio__input.is-checked .el-radio__inner,
.list_table >>> .el-radio__input.is-indeterminate .el-radio__inner {
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0px 0px 0px 2px #39526f inset;
}
.list_table >>> .el-radio__inner {
  border-radius: 50%;
  background: transparent;
  width: 24px;
  height: 24px;
}
.list_table >>> .el-radio__inner::after {
  display: none;
}
/* ------ */
.list_table {
  margin-top: 40px;
}
.c_radio_box {
  margin-bottom: 25px;
}
/* --- */

/* 费用 弹框表格 */
.c_fee_box {
  box-sizing: border-box;
  padding: 44px 68px;
}
.c_f_t1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
.c_b1 {
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #191e29;
  display: flex;
  flex-wrap: wrap;
}
.c_b2 {
  width: 50%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}
.c_b3 {
  width: 50%;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.c_b1_text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
  margin-top: 12px;
  word-break: break-word;
}

/* ------- */
.link_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.link_text {
  cursor: pointer;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #deb981;
  padding-right: 20px;
}
.btm_text {
  font-size: 15px;
  color: #ffffff;
  opacity: 0.6;
  text-align: right;
  padding-top: 10px;
}
.c_box {
  box-sizing: border-box;
  padding: 28px;
  background: #232a36;
  border-radius: 16px;
  margin-bottom: 20px;
}
.c_box_title {
  margin-bottom: 15px;
  font-size: 18px;
}
.card_box {
  display: flex;
}
.card_bgc {
  width: 395px;
  /* min-height: 240px; */
  background: linear-gradient(96deg, #2d343a 0%, #071018 100%);
  /* background: url(../assets/img/card_bgc.png) no-repeat;
    background-size: 100% 100%; */
  border-radius: 10px;
  box-sizing: border-box;
  padding: 34px 31px 18px 38px;
}
.card_logo_box img {
  width: 106px;
}
.cord_num {
  color: #fff;
  font-size: 22px;
  margin: 25px 0;
  display: flex;
  justify-content: space-between;
}
.cord_text {
  color: #ddd;
  font-size: 20px;
  margin-bottom: 20px;
  height: 24px;
}
.cord_btm_num {
  display: flex;
  justify-content: space-between;
  color: #ddd;
  font-size: 12px;
  align-items: flex-end;
}
.btm_t1 {
  color: #888;
  font-size: 12px;
}
.btm_t2 {
  color: #fff;
  font-size: 12px;
  margin-top: 12px;
}
.btm_t_img {
  width: 77px;
}
.c_box_right {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
  padding-left: 28px;
  position: relative;
}
.right_color {
  color: #6d7279;
}
.right_color2 {
  color: #fff;
}
.login_btn,
.login_btn:hover {
  min-width: 184px;
  height: 42px;
  background: #00c18e;
  /* box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2); */
  border-color: #00c18e;
  border-radius: 4px;
  color: #191e29;
  margin-top: 10px;
  font-size: 14px;
}
.mini_btn,
.mini_btn:hover {
  background: #00c18e;
  border-color: #00c18e;
  color: #191e29;
}
.width_css,
.width_css:hover {
  min-width: 107px;
}
.c_right_t1 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 4px;
}
.c_right_t2 span{
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  margin-bottom: 12px;
}
.c_t_txt1{
  color: #00c18e;
}
.card_logo_box .look_icon {
  width: 22px;
  height: 15px;
  cursor: pointer;
}
.card_logo_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top_text {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  word-break: break-word;
}
.top_text2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1 {
  display: flex;
  border-bottom: 1px solid #314b69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left {
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}
.info_1_right {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text3 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.amount_box {
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223c58;
}
.top_text4 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 8px;
}
.top_text5 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text5_2:nth-child(8) {
  padding-top: 10px;
}
.top_text5_2 {
  padding-top: 2px;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner {
  /* width: 224px; */
  height: 68px;
  background: #333a47;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input {
  width: 100%;
}
.zdy_input {
  display: flex;
}
.zdy_form >>> .el-form-item__label {
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box {
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #191e29;
}
.type_box1 {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img {
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3 {
  color: rgba(255, 255, 255, 0.8);
}
.bz_list {
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1 {
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child {
  margin-bottom: 0;
}
.inp_btm_tit {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin {
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6 {
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7 {
  /* padding: 18px 12px 20px; */
  /* background: #191E29; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
}
.div_num {
  flex: 1;
  background: #333a47;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}
.top_text7_2 {
  padding: 18px 12px 20px;
  background: #191e29;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  min-width: 120px;
  text-align: center;
}
.top_text8 {
  display: flex;
  margin-top: 12px;
}
.top_text8 > div {
  width: 50%;
}
.top_text9 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text10 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}
.warning_red {
  background: #fedfe0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow {
  background: #e8dac8;
}
.warning_red_icon i {
  color: #f35f65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #f35f65;
}
.warning_yellow_icon i,
.warning_yellow_text {
  color: #b28247;
}
.top_up_link {
  color: #041728;
  text-decoration: underline;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  min-width: 120px;
  color: #bbbbbb;
  border-color: #bbbbbb;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #00c18e;
  background: #00c18e;
  /* box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2); */
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #191e29;
  margin-left: 20px;
}

.b_status_btn,
.b_status_btn:hover,
.b_status_btn:active,
.b_status_btn:focus {
  border-color: #00c18e;
  background: transparent;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  cursor: auto;
}
.b_status_btn_red,
.b_status_btn_red:hover,
.b_status_btn_red:active,
.b_status_btn_red:focus {
  border-color: red;
}
.refresh_icon {
  width: 22px;
  margin-left: 5px;
  cursor: pointer;
  margin-bottom: -2px;
}
.c_box_right >>> .el-button:first-child {
  margin-right: 10px;
  margin-left: 0;
}
.c_box_right >>> .el-button + .el-button {
  margin-right: 10px;
  margin-left: 0;
}
.bgc_yellow,
.bgc_yellow:hover {
  background: #e3a84e;
  border-color: #e3a84e;
}
.radio_row,
.radio_btm_txt {
  line-height: initial;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
}
.rep_title {
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: initial;
}
.rep_form >>> .el-radio,
.rep_form >>> .el-radio__input.is-checked + .el-radio__label {
  color: #fff;
  margin-top: 20px;
}
.radio_btm_txt {
  margin-top: 11px;
  box-sizing: border-box;
  padding-left: 24px;
}
.row_retract {
  box-sizing: border-box;
  padding-left: 24px;
}
.rep_form >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #fff;
  background: transparent;
}
.rep_form >>> .el-radio__inner::after {
  width: 8px;
  height: 8px;
}
.rep_form >>> .el-radio__inner {
  background-color: transparent;
}
.rep_form_top {
  border-bottom: 1px solid #020d16;
  box-sizing: border-box;
  padding-bottom: 25px;
}
.rep_form_btm {
  box-sizing: border-box;
  padding-top: 25px;
}
.rep_form_btm >>> .el-form-item__label {
  line-height: inherit;
}
.rep_form_btm >>> .el-form-item {
  margin-top: 20px;
  margin-bottom: 0;
}
.rep_form_btm >>> .el-form--label-top .el-form-item__label {
  padding: 0 0 5px;
  color: rgba(255, 255, 255, 0.6);
}
.card_set_title {
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: initial;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 15px;
}
.card_set_title span {
  color: #fff;
}
.card_set_title_btm {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin: 20px 0;
  color: rgba(255, 255, 255, 0.6);
}
.card_set_checkbox >>> .el-checkbox,
.card_set_checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.card_set_checkbox >>> .el-checkbox__inner {
  background-color: transparent;
  border-color: #fff;
}
.mbtm {
  margin-bottom: 10px;
}
.form_p_1 {
  display: flex;
  justify-content: space-between;
}
.form_p_2 {
  width: 40%;
}
.form_p_3 {
  width: 55%;
}
.min_max_box {
  display: flex;
  justify-content: space-between;
}
.tup_checkbox,
.tup_checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
  white-space: pre-wrap;
  display: flex;
}
</style>

<style>
.top_up_dlg {
  max-height: 95vh;
  overflow-y: auto;
}
.top_up_dlg::-webkit-scrollbar {
  width: 5px;
}
.top_up_dlg::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #00c18e;
}

.card_dlg .el-dialog__body {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
.card_dlg .el-dialog__header {
  padding: 20px 20px 16px;
}
@media screen and (max-width: 850px) {
  .card_dlg_mobile {
    top: 5px;
    transform: translate(-50%, 0);
  }
}

/* ------ */
.bz_pop {
  color: #fff;
  font-size: 15px;
  background: #191e29;
  box-shadow: 0px 0px 4px #191e29;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
.btm_text2 {
  line-height: initial;
  padding-top: 5px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}

.replace_dlg_posi {
  top: 0;
  transform: translate(-50%, 0);
}
@media screen and (max-height: 840px) {
  .replace_dlg_posi {
    top: 0;
    transform: translate(-50%, 0);
  }
}
.replace_txt_click {
  cursor: pointer;
  color: #00c18e;
  text-decoration: underline;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .card_box1 {
    margin: 50px 0 30px;
  }
  .c_fee_box {
    padding: 25px 30px;
  }
  .c_b2 {
    width: 65%;
  }
  .c_b3 {
    width: 35%;
  }

  /* ------- */
  .c_box {
    display: block;
  }
  .card_bgc {
    width: 100%;
    padding: 15px 20px;
  }
  .c_box {
    padding: 10px;
  }
  .c_box_right {
    padding-left: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .card_box {
    display: flex;
    flex-direction: column;
  }
  .b_status_btn,
  .b_status_btn:hover,
  .b_status_btn:active,
  .b_status_btn:focus {
    top: 15px;
  }
}
</style>
